/*
 * cmn.js
 */

// import jQuery from 'jquery';  //node_modlesの中にあるものを使用探しに行ってくれる
import $ from 'jquery';
import 'jquery.cookie';
import 'slick-carousel';
import '../scss/style.scss';
import MatchHeight from './matchHeight';
// 要素が存在するかチェック
if ($('.p-vlist__text').length > 0 && $('.p-vlist').length > 0) {
  new MatchHeight('.p-vlist__text', '.p-vlist');
}

$(function(){
/* ==========================================================
!stack
========================================================== */
/* 関数の読み込み
------------------------------------ */
  spMenu();
  pcMenu();
  ftMenu();
  switchLang();
  pageTop();
  pageTopFixed();
  pageScroll();
  accordion();
  tabMenu();
  scrollableArea();
  zoom();
  currentLocation();
  currentBtn();
  mapModal();
  beforeAfter();
  scrollAnimation();
  telLink();
  Cookie();
});


/* アンカー付きページ移動処理
-------------------------------------------------- */
$(window).on("load", function () {
  const hash = location.hash; //ハッシュを取得
  // console.log(hash);
  /* window.matchMedia
  ------------------------------------ */
  if (window.matchMedia("(max-width:768px)").matches) {
    // (1)windowの読み込みが完了したときに、768px以下の場合に行いたいもの
    if($(hash).length) {
      $("html, body").animate({
        scrollTop: $(hash).offset().top - 80,
      },500);
    }

  } else {
    // (2)windowの読み込みが完了したときに、769px以上の場合に行いたいもの
    if($(hash).length) {
      $("html, body").animate({
        scrollTop: $(hash).offset().top - 120,
      },500);
    }
  }
});

// グローバル
const pointSPHeader = window.matchMedia('screen and (max-width: 1023px)');
const pointSPFooter = window.matchMedia('screen and (max-width: 959px)');
let beforePos = 0;

// debounce関数の定義
const debounce = (func, wait) => {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

/* spMenu
-------------------------------------------------- */
const spMenu = function () {
  const $openBtn = $('.js-spMenu-openBtn');
  const $closeBtn = $('.js-spMenu-closeBtn');
  const $spMenu = $('#spMenu');
  const $spOverlay = $('.js-spMenu-overlay');
  const $background = $('.js-menu-background');
  const $spMenuBackground = $('.js-spMenu-background');
  const $body = $('body');
  let w = $(window).width();
  let scrollpos = 0;
  let contactPosition = 0; // お問い合わせリンクのターゲット位置を保存

  // ページ読み込み時にお問い合わせリンク位置を保存
  function saveContactPosition() {
    const target = $('.p-footer-menu.-contact');
    if (target.length) {
      contactPosition = target.offset().top; // ターゲット位置を取得
    }
  }

  // SPメニュー開く
  function openMenu() {
    scrollpos = $(window).scrollTop(); // 現在のスクロール位置を記録
    $spOverlay.fadeIn();
    $spMenu.attr('aria-hidden', 'false');
    $openBtn.attr('aria-expanded', 'true').hide();
    $closeBtn.attr('aria-expanded', 'true');
    $body.addClass('fix-body').css({ top: -scrollpos }); // スクロール位置を保存して固定
    $background.attr('inert', 'true');
    $spMenuBackground.attr('inert', 'true');
  }

  // SPメニュー閉じる
  function closeMenu() {
    $spOverlay.fadeOut();
    $spMenu.attr('aria-hidden', 'true');
    $closeBtn.attr('aria-expanded', 'false');
    $body.removeClass('fix-body').css({ top: '' }); // 固定解除
    $(window).scrollTop(scrollpos); // 記録されたスクロール位置に戻す
    $background.removeAttr('inert');
    $spMenuBackground.removeAttr('inert');
    $openBtn.attr('aria-expanded', 'false');
  }

  //SPメニュー開く
  $openBtn.on('click', function(){
    openMenu();
  });
  //SPメニュー閉じる
  $closeBtn.on('click', function(){
    closeMenu();
    setTimeout(function(){
      $openBtn.show();
    }, 200 );
  });
  $spOverlay.on('click', function(){
    closeMenu();
    setTimeout(function(){
      $openBtn.show();
    }, 200 );
  });

  //お問い合わせリンクのクリック処理
  $('.l-menu__functions .c-btn-contact').on('click', function (e) {
    e.preventDefault();
    if (contactPosition) {
      closeMenu();
      setTimeout(function() {
        $openBtn.show();
        $('html, body').animate({ scrollTop: contactPosition - 80 }, 500)
      }, 200);
    }
  });

  // ブレークポイントチェック
  function checkBreakPoint() {
    if (!pointSPHeader.matches) {
      closeMenu();
    }
  }

  // 初期化処理
  if (w < 1024) {
    closeMenu();
  }

  pointSPHeader.addListener(checkBreakPoint);

  //ページロード時にターゲット位置を保存
  $(window).on('load', function(){
    saveContactPosition();
  });

  //ページ遷移後のターゲット位置保存
  $(window).on('pageshow', function(){
    saveContactPosition();
  });
};

/* pcMenu
-------------------------------------------------- */
const pcMenu = function(){
  const $pcMenu = $('.js-pcMenu');
  const $openBtns = $('.js-pcMenu-openBtn');
  const $closeBtns = $('.js-pcMenu-closeBtn');
  const $pcOverlay = $('.js-pcMenu-overlay');
  const $background = $('.js-menu-background');
  const $pcMenuBackground = $('.js-pcMenu-background');
  const $body = $('body');
  let w = $(window).width();
  let scrollpos = 0;

  //PCメニュー開く
  $openBtns.on('click', function(){
    openPcMenu();
    const target = '#' + $(this).attr('aria-controls');
    $(target).show().attr('aria-modal','true').attr('aria-hidden','false');
    $(this).attr('aria-expanded','true');
  });
  //PCメニュー閉じる
  $closeBtns.on('click', function(){
    closePcMenu();
  });
  $pcOverlay.on('click', function(){
    closePcMenu();
  });

  function openPcMenu() {
    $openBtns.attr('aria-expanded','false');
    $pcMenu.hide().removeAttr('aria-modal').attr('aria-hidden','true');
    $pcOverlay.fadeIn();
    $background.attr('inert','true');
    $pcMenuBackground.attr('inert','true');
    scrollpos = $(window).scrollTop();
    // console.log(scrollpos);
    $body.addClass('fix-body').css({"top": -scrollpos});
  }
  function closePcMenu() {
    $openBtns.attr('aria-expanded','false');
    $pcMenu.hide().removeAttr('aria-modal').attr('aria-hidden','true');
    $pcOverlay.fadeOut();
    $background.removeAttr('inert');
    $pcMenuBackground.removeAttr('inert');
    $body.removeClass('fix-body').css({"top": 0});
    $('html, body').animate({scrollTop:scrollpos},0);
  }

  function checkBreakPoint() {
    if (pointSPHeader.matches) {
      closePcMenu();
    }
  }
  if(w >= 1024){
    closePcMenu();
  }

  pointSPHeader.addListener(checkBreakPoint);
}

/* ftMenu
-------------------------------------------------- */
const ftMenu = function() {
  const $toggleBtns = $('.js-ft-toggleBtn');
  const $ftMenus = $('.js-ft-menu');
  let w = $(window).width();

  //メニュー開閉
  $toggleBtns.on('click', function(){
    let expanded = $(this).attr('aria-expanded');
    let target = '#' + $(this).attr('aria-controls');

    if(expanded == 'false'){
      //開く
      $toggleBtns.attr('aria-expanded','false');
      $ftMenus.attr('aria-hidden','true').slideUp();
      $(this).attr('aria-expanded','true');
      $(target).attr('aria-hidden','false').slideDown();
    }else {
      //閉じる
      $toggleBtns.attr('aria-expanded','false');
      $ftMenus.attr('aria-hidden','true').slideUp();
    }
  });

  //メニュー初期化
  function initMenu () {
    $toggleBtns.attr('aria-expanded','true');
    $ftMenus.attr('aria-hidden','false').show();
  }
  //メニューリセット
  function resetMenu() {
    $toggleBtns.removeAttr('aria-expanded');
    $ftMenus.removeAttr('aria-hidden').show();
  }

  function checkBreakPoint() {
    if (!pointSPFooter.matches) {
      resetMenu();
    }else {
      initMenu();
    }
  }
  if(w < 960){
    initMenu();
  }

  pointSPFooter.addListener(checkBreakPoint);
}

/* switchLang
-------------------------------------------------- */
const switchLang = function() {

  $.getJSON('/common/json/langData.json', function(data) {
    const langData = data;

    $('.js-switchLangButton').on('click', function() {
      const lang = $(this).data('lang');

      // 切り替えボタンの見た目を更新
      $('.js-switchLangButton').removeClass('is-current');
      $(this).addClass('is-current');

      // 対象リンクを更新
      const targetData = langData[lang].target;
      const $switchLangTarget = $('.js-switchLangTarget');
      $switchLangTarget.text(targetData.text);
      $switchLangTarget.attr('href', targetData.url);

      // メニュー項目を更新
  const menuData = langData[lang].menu;
  const $switchLangAncestor = $(this).closest('.js-switchLang'); // クリックしたボタンのルートにある .js-switchLang 要素
  const $switchSubLinks = $switchLangAncestor.find('.js-switchSubLinks'); // ルート要素内の .js-switchSubLinks 要素
  $switchSubLinks.find('a').each(function(index) {
        if (menuData[index]) { // メニューのデータが存在するか確認
      $(this).text(menuData[index].text);
      $(this).attr('href', menuData[index].url);
        } else {
      console.warn(`メニューのデータが見つかりません: インデックス ${index}`);
        }
    });
    });
  }).fail(function() {
    console.error('JSONファイルの読み込みに失敗しました。');
  });

/* もっと見る
------------------------------------ */
  // 表示させる要素の総数をlengthメソッドで取得
  var $numberListLen = $(".--recommend-list li").length;
  // デフォルトの表示数
  var defaultNum = 6;
  // ボタンクリックで追加表示させる数
  var addNum = 6;
  // 現在の表示数
  var currentNum = 0;

  $(".--recommend-list").each(function() {
    // moreボタンを表示し、closeボタンを隠す
    $(this).find(".c-more-button").show();

    // defaultNumの数だけ要素を表示
    // defaultNumよりインデックスが大きい要素は隠す
    $(this).find("li:not(:lt("+defaultNum+"))").hide();

    // 初期表示ではデフォルト値が現在の表示数となる
    currentNum = defaultNum;

    // moreボタンがクリックされた時の処理
    $(".btn_more01").on('click',function(){
      // 現在の表示数に追加表示数を加えていく
      currentNum += addNum;

      // 現在の表示数に追加表示数を加えた数の要素を表示する
      $(this).parent().siblings().find("li:lt("+currentNum+")").slideDown();

      // 表示数の総数よりcurrentNumが多い=全て表示された時の処理
      if($numberListLen <= currentNum) {
        // 現在の表示数をデフォルト表示数へ戻す
        currentNum = defaultNum;

        // moreボタンを隠す
        $(".c-more-button").hide();
      }
    });
  });
}

/* ==========================================================
!pageTop
========================================================== */
const pageTop = function () {
  $(".pagetop").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 1000, "easeInOutCubic");
    return false;
  });
};
/* ==========================================================
!fixed pagetop scroll
========================================================== */
const pageTopFixed = function () {
  const pageTopBox = $(".pagetop_fixed");
  const pageTopLink = $(".pagetop_fixed p");

  pageTopLink.click(function () {
    $("html, body").animate({ scrollTop: 0 }, 1000, "easeInOutCubic");
    return false;
  });

  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 150) {
      pageTopBox.fadeIn();
    } else {
      pageTopBox.fadeOut();
    }

    const scrollHeight = $(document).height();
    const scrollPosition = $(window).height() + $(window).scrollTop();
    const footHeight = $("#footer").innerHeight();
    if (scrollHeight - scrollPosition <= footHeight) {
      pageTopLink.css({ position: "absolute", bottom: "0px" });
    } else {
      pageTopLink.css({ position: "fixed", bottom: "0px" });
    }
  });
};
/* ==========================================================
!pageScroll
========================================================== */
const pageScroll = function () {
  // jQuery.easing.easeInOutCubic = function (x, t, b, c, d) {
  // 	if ((t /= d / 2) < 1) return (c / 2) * t * t * t + b;
  // 	return (c / 2) * ((t -= 2) * t * t + 2) + b;
  // };
  $("a[href*='#']:not('.inline'), .scroll").click(function () {
    $("html, body").animate(
      {
        scrollTop: $($.attr(this, "href")).offset().top - 120, // - 70 等といれるとそのピクセル数分増えた状態でスクロールが止まる(ヘッダー固定の時に利用)
      },
      500
    );
    return false;
  });
};
/* ==========================================================
!Accordion
========================================================== */
const accordion = function () {
  const $accordionBtns = $('.js-accordionBtn');
  const $accordionPanels = $('.js-accordionPanel');

  //存在チェック
  if (!$accordionBtns) {
    return;
  }


  $accordionBtns.on('click', function(){
    let expanded = $(this).attr('aria-expanded');

    if(expanded == 'false') {
      //開く
      $accordionBtns.attr('aria-expanded', 'false');
      $accordionPanels.attr('aria-hidden', 'true').slideUp();
      let target = '#' + $(this).attr('aria-controls');
      $(this).attr('aria-expanded', 'true');
      $(target).attr('aria-hidden', 'false').slideDown();
    }else {
      //閉じる
      $accordionBtns.attr('aria-expanded', 'false');
      $accordionPanels.attr('aria-hidden', 'true').slideUp();
    }
  });
};
/* ==========================================================
!tab
========================================================== */
const tabMenu = function () {
  const $tab = $('.p-tabarea');

  //存在チェック
  if (!$tab) {
    return;
  }


  $tab.each(function(){
    const $tabButtons = $(this).find('[role="tab"]');
    const $tabPanels = $(this).find('[role="tabpanel"]');

    $tabButtons.on('click',function(){
      let expanded= $(this).attr('aria-selected');

      if(expanded == 'false') {
        //タブ切り替え
        $tabButtons.attr('aria-selected', 'false').attr('aria-expanded', 'false');
        $tabPanels.attr('aria-hidden', 'true').hide();
        let target = '#' + $(this).attr('aria-controls');
        $(this).attr('aria-selected','true').attr('aria-expanded', 'true');
        $(target).attr('aria-hidden', 'false').fadeIn();
      }else {
        return false;
      }
    });

  });


};
/* ==========================================================
!scrollableArea
========================================================== */
const scrollableArea = function () {
  const $scrollable = $('.js-scrollable');

  //存在チェック
  if (!$scrollable) {
    return;
  }

  // .js-scrollableが複数存在するため、各要素に対して処理を行う
  $scrollable.each(function() {
    let totalWidth = 0;
    // .js-scrollable__targetの直下の子要素のwidthを合計する
    $(this).find('.js-scrollable__target > *').each(function() {
        totalWidth += $(this).outerWidth(true); // trueを指定するとmarginも含めた外側の幅を取得する
    });
    const $scrollableCaption = $(this).find('.js-scrollable__caption');
    const $scrollableWrap = $(this).find('.js-scrollable__wrap');
    const wrapperWidth = $scrollableWrap.width();


    if(wrapperWidth < totalWidth) {
      $scrollableCaption.show();
      $scrollableWrap.css("overflow","auto");
    }else {
      $scrollableCaption.hide();
      $scrollableWrap.css("overflow","visible");
    }

});

  $(window).on('resize', debounce(scrollableArea, 250));
}

/* ==========================================================
!Modal
========================================================== */
const body = document.body;
let scrollpos = 0;

const showModal = (modal) => {
  scrollpos = window.scrollY;
  modal.showModal();
  body.classList.add('fix-body');
  body.style.top = `-${scrollpos}px`;
  // .l-modal__innerと.l-modal__contentsの幅を比較
  const modalInner = modal.querySelector('.l-modal__inner');
  const modalContents = modal.querySelector('.l-modal__contents');

  // if (modalInner && modalContents && modalContents.scrollWidth > modalInner.clientWidth) {
  if (modalContents.scrollWidth > modalInner.clientWidth) {
    modal.classList.add('is-scrollable');

    // 3秒後に.is-scrollableクラスを削除
    setTimeout(() => {
      modal.classList.remove('is-scrollable');
    }, 3000);
  }

  // Escキーでモーダルを閉じる
  const handleEscKey = (e) => {
    if (e.key === 'Escape') {
      closeModal(modal, null, e);
    }
  };

  window.addEventListener('keydown', handleEscKey);

  modal.addEventListener('close', () => {
    window.removeEventListener('keydown', handleEscKey);
  }, { once: true });
};

const closeModal = (modal, closeTrigger, e) => {
  if (e.target === modal || e.target === closeTrigger || e.key === 'Escape') {
    modal.close();
    body.classList.remove('fix-body');
    body.style.top = '0';
    window.scrollTo(0, scrollpos);
  }
};

/* ==========================================================
!mapModal
========================================================== */
const mapModal = function() {
  const mapModal = document.getElementById("search-map-modal");
  const searchMap = document.getElementById('search-map');
  const mapOpenTrigger = document.querySelector(".js-openMap");
  const areaOpenTriggers = document.querySelectorAll(".js-areaOpenMap");
  const mapCloseTrigger = document.querySelector(".js-closeMap");

  //存在チェック
  if (!mapModal) {
    return;
  }


  //モーダルを開く
  const showMapModal = () => showModal(mapModal);
  //モーダルを閉じる
  const closeMapModal = (e) => {
    if (searchMap.classList.contains('is-map')) {
      searchMap.classList.remove('is-map');
    }
    closeModal(mapModal, mapCloseTrigger, e);
  };

  // マップを開くボタンがクリックされた時に、モーダルを開くイベントを追加
  if (mapOpenTrigger) {
    mapOpenTrigger.addEventListener("click", function() {
      showMapModal();
      searchMap.classList.add('is-map');
    });
  }
  // エリアを開くボタンがクリックされた時に、モーダルを開くイベントを追加
  if (areaOpenTriggers) {
    areaOpenTriggers.forEach(function(areaOpenTrigger){
      areaOpenTrigger.addEventListener("click", function() {
        showMapModal();
        // areaOpenTrigger自身のdata-area属性の値を取得
        const areaValue = areaOpenTrigger.getAttribute('data-area');

        // .p-search-map__area > divを取得
        const areaDivs = document.querySelectorAll('.p-search-map__area > div');

        // 各divのクラスと比較し、同じ値のところにis-currentを追加
        areaDivs.forEach(function(div) {
          if (div.classList.contains(areaValue)) {
            div.classList.add('is-current');
          } else {
            div.classList.remove('is-current'); // 他の要素からはis-currentを削除
          }
        });
      });
    });
  }

  // モーダル自体がクリックされた時に、モーダルを閉じるイベントを追加
  if (mapModal) {
    mapModal.addEventListener("click", closeMapModal);
  }

  // モーダルを閉じるボタンがクリックされた時に、モーダルを閉じるイベントを追加
  if (mapCloseTrigger) {
    mapCloseTrigger.addEventListener("click", closeMapModal);
  }

  // 共通のリンククリック処理を行う関数
  const handleLinkClickCommon = (target, hrefAttribute) => {
    if (target) {
      event.preventDefault(); // デフォルトのリンク動作を防止

      // モーダルを閉じる
      mapModal.close();
      body.classList.remove('fix-body');
      body.style.top = '0';
      window.scrollTo(0, scrollpos);

      // ページ内アンカーへスクロールリンク
      const anchorId = target.getAttribute(hrefAttribute);

      if (anchorId) {
        setTimeout(() => {
          const anchorElement = document.querySelector(anchorId);
          if (anchorElement) {
            const offset = 100; // 100pxのオフセット
            const elementPosition = anchorElement.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }, 0); // タイムアウトを追加して、スクロールを確実にする
      }
    }
  };

  // SVG内のリンクエリアのクリックイベントを処理
  const handleLinkClick = (e) => {
    const target = e.target.closest('a');
    handleLinkClickCommon(target, 'xlink:href');
  };

  // エリアMap内のbutton要素クリックイベントを処理
  const handleLinkClickButton = (e) => {
    const target = e.target.closest('button');
    handleLinkClickCommon(target, 'data-href');
  };

  // SVG内のリンクエリアのクリックイベントを処理
  const mapContents = document.getElementById("search-map");
  if (mapContents) {
    mapContents.addEventListener("click", handleLinkClick);
  }

  // モーダル内のbuttonのクリックイベントを処理
  const modalLinks = mapModal.querySelectorAll('button');
  if(modalLinks) {
    modalLinks.forEach((link) => {
      link.addEventListener('click', handleLinkClickButton);
    });
  }
}


/* ==========================================================
!zoom
========================================================== */
const zoom = function () {
  const zoomContainers = document.querySelectorAll(".js-zoom");

  // 存在チェック
  if (!zoomContainers || zoomContainers.length === 0) {
    return;
  }

  zoomContainers.forEach(container => {
    const zoomModal = container.querySelector(".js-zoom__modal");
    const zoomTrigger = container.querySelector(".js-zoom__fig");
    const closeTrigger = container.querySelector(".js-zoom__modal-close");

    // モーダルを開く
    const showZoomModal = () => showModal(zoomModal);
    // モーダルを閉じる
    const closeZoomModal = (e) => closeModal(zoomModal, closeTrigger, e);

    // alwaysFlagの設定
    const alwaysFlag = container.classList.contains('_always');

    const handleZoom = function () {
      const isSmallScreen = window.innerWidth < 768;

      // イベントリスナーの解除
      zoomTrigger.removeEventListener("click", showZoomModal);
      zoomModal.removeEventListener("click", closeZoomModal);
      closeTrigger.removeEventListener("click", closeZoomModal);

      // モーダルを閉じる
      zoomModal.close();

      if (alwaysFlag || isSmallScreen) {
        // イベントリスナーの登録
        zoomTrigger.addEventListener("click", showZoomModal);
        zoomModal.addEventListener("click", closeZoomModal);
        closeTrigger.addEventListener("click", closeZoomModal);
      }
    };

    handleZoom();
    window.addEventListener('resize', debounce(handleZoom, 250));
  });
};

/* ==========================================================
!currentLocation
========================================================== */
const currentLocation = function () {
  const $target = $(".js-currentLocation");
  const $targetMenu = $target.find("a");

  // 存在チェック
  if (!$target || $target.length === 0) {
    return;
  }

  // クリックイベントで aria-current を更新
  $targetMenu.on("click", function() {
    $targetMenu.removeAttr("aria-current");
    $(this).attr("aria-current", "location");
  });

  // スクロールイベントで aria-current を更新
  $(window).on("scroll", function() {
    let currentSection = null;
    let scrollPosition = $(window).scrollTop();

    $targetMenu.each(function() {
      const sectionId = $(this).attr("href");  // リンクの href を取得
      const $section = $(sectionId);  // 対応するセクションの DOM 要素

      if ($section.length) {  // セクションが存在する場合
        const sectionOffset = $section.offset().top - 50; // 上端に少し余裕を持たせる
        const sectionHeight = $section.outerHeight();

        // スクロール位置がセクション内にあるかチェック
        if (scrollPosition >= sectionOffset && scrollPosition < sectionOffset + sectionHeight) {
          currentSection = $(this);
        }
      }
    });

    // aria-current の更新
    if (currentSection) {
      $targetMenu.removeAttr("aria-current");
      currentSection.attr("aria-current", "location");
    }
  });
}

/* ==========================================================
!currentBtn
========================================================== */
const currentBtn = function () {
  const $currentItem = $(".js-currentBtn");
  const $currentLink = $currentItem.find("a");

  // 存在チェック
  if (!$currentItem || $currentItem.length === 0) {
    return;
  }

  // クリックイベントで is-current を更新
  $currentLink.on("click", function() {
    $currentLink.removeClass("is-current");
    $(this).addClass("is-current");
  });
}

/* ==========================================================
!beforeAfterSlider
========================================================== */
const beforeAfter = function () {
  $('.js-beforeAfter').each(function () {
    var $sliderContainer = $(this);
    var $boxBefore = $sliderContainer.find('.js-boxBefore');
    var $sliderRange = $sliderContainer.find('.js-beforeAfterHandle');

    function beforeAfterSlider() {
      $boxBefore.css('width', $sliderRange.val() + '%');
    }

    $sliderRange.on('input', beforeAfterSlider);
    $sliderRange.on('change', beforeAfterSlider);
  });
}

/* ==========================================================
!Scroll Animation
========================================================== */
const scrollAnimation = function () {
  const AnimTrigger = $(".effect"); //アニメーショントリガー
  const windowHeight = $(window).height(); //ウインドウの高さ

  // ロードした際に可視範囲に入っていたら実行される
  $(window).on("load", function () {
    AnimTrigger.each(function () {
      const imgPos = $(this).offset().top; //「AnimTrigger」の位置

      if (imgPos < windowHeight) {
        $(this).addClass("aniOn");
      }
    });
  });

  // スクロールした際に「AnimTrigger」ごとに、以下に記述する内容が実行される
  $(window).scroll(function () {
    const scroll = $(window).scrollTop(); //スクロールした量

    AnimTrigger.each(function () {
      const imgPos = $(this).offset().top; //「AnimTrigger」の位置

      //アニメーションする条件＝「画面の下から1/5まできた時点でアニメーション」
      if (scroll > imgPos - windowHeight + windowHeight / 5) {
        //スクロール量　が次の条件より多いとき　…　条件：トリガーの場所　引く　ウィンドウの高さ　足す　ウィンドウの高さ　割る　5（- windowHeight + windowHeight / 5 なので6/5でなく4/5）
        $(this).addClass("aniOn");
      }
    });
  });
};


/* ==========================================================
!Tel Link
========================================================== */
const telLink = function() {
  var ua = navigator.userAgent;
  if(ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0){
    $('.js-tel-link').each(function(){
      var str = $(this).text();
      $(this).html($('<a>').attr('href', 'tel:' + str.replace(/-/g, '')).append(str + '</a>'));
    });
  }
}

/* ==========================================================
!Cookie
========================================================== */
const Cookie = function() {
  const expire = 365; // 有効期限（日）
  let cc = document.querySelector('.l-cookie__consent');
  let ca = document.querySelector('.l-cookie__agree');
  const flag = localStorage.getItem('popupFlag');
  if (flag != null) {
    const data = JSON.parse(flag);
    if (data['value'] == 'true') {
      popup();
    } else {
      const current = new Date();
      if (current.getTime() > data['expire']) {
        setWithExpiry('popupFlag', 'true', expire);
        popup();
      }
    }
  } else {
    setWithExpiry('popupFlag', 'true', expire);
    popup();
  }
  ca.addEventListener('click', () => {
    cc.classList.add('cc-hide1');
    setWithExpiry('popupFlag', 'false', expire);
  });

  function setWithExpiry(key, value, expire) {
    const current = new Date();
    expire = current.getTime() + expire * 24 * 3600 * 1000;
    const item = {
      value: value,
      expire: expire
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  function popup() {
    cc.classList.add('is-show');
  }
}